import { Instagram } from 'lucide-react'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="py-12" style={{ backgroundColor: 'var(--color-dark)' }}>
      <div className="container-custom">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault()
              window.scrollTo({ top: 0, behavior: 'smooth' })
            }}
            className="font-heading text-2xl tracking-wide text-white"
          >
            OM with Madi
          </a>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.instagram.com/omwithmadi/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-white/80 hover:text-white transition-colors"
              aria-label="Follow on Instagram"
            >
              <Instagram size={24} />
            </a>
          </div>

          {/* Copyright */}
          <p className="text-sm text-white/60">
            &copy; {currentYear} OM with Madi. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
